<script setup lang="ts">
import { useRoute } from 'vue-router';
import NavBar from '@send-frontend/apps/send/components/NavBar.vue';
import FooterBar from '@send-frontend/apps/send/components/FooterBar.vue';

const route = useRoute();
const isPrintMode = route.query.print !== undefined;
</script>

<template>
  <template v-if="isPrintMode">
    <slot></slot>
  </template>
  <template v-else>
    <NavBar />

    <div class="content">
      <slot></slot>
    </div>

    <!--
      id used by the mobile upload sidebar (HomeView) to detect when the footer
      scrolls into view so the bottom-docked bar can park above it instead of
      overlapping it (see #977).
    -->
    <div id="send-footer">
      <FooterBar />
    </div>
  </template>
</template>

<style lang="css" scoped>
.content {
  min-height: calc(100vh - 250px - 60px);
}
</style>
